"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var service_service_1 = require("src/app/Services/service.service");
var core_1 = require("@angular/core");
var PageNotFoundComponent = /** @class */ (function () {
    function PageNotFoundComponent(service) {
        this.service = service;
        this.service.disclaimerIsReady = true;
    }
    PageNotFoundComponent.prototype.ngOnInit = function () {
    };
    return PageNotFoundComponent;
}());
exports.PageNotFoundComponent = PageNotFoundComponent;
